var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({color: _vm.color})},[_c('i',{staticClass:"fas fa-check-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }